// richClipboard — single copy-to-clipboard helper for content with both an
// HTML flavour (pastes as a real table into Outlook/Word) and a plain-text
// flavour. Leaf module with no intra-utils imports so component tests can
// mock it in isolation.
//
// Attempt order: rich write (both flavours via ClipboardItem) when the API
// exists and html is provided, then plain writeText. Rejects when every
// attempt fails (e.g. clipboard permission denied) — callers must surface
// that; a silent no-op here means an invisible copy failure.

export async function copyRichText(html: string | undefined, text: string): Promise<void> {
  if (html && typeof ClipboardItem !== "undefined") {
    try {
      await navigator.clipboard.write([
        new ClipboardItem({
          "text/html": new Blob([html], { type: "text/html" }),
          "text/plain": new Blob([text], { type: "text/plain" }),
        }),
      ]);
      return;
    } catch {
      // Rich clipboard unavailable (older Safari, permissions): fall through.
    }
  }
  await navigator.clipboard.writeText(text);
}
